module.exports = __webpack_public_path__ + "sg.svg?279844e992ca5aa5bbf4d830b2b79be6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/sg.svg
// module id = 1605
// module chunks = 0